import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOtherVendorsList, getOtherVendorsListRFTS } from "../../store/actions/po";
import { filterName } from "../../utils/Utils";
import ModalButton from "../../components/modalButton/modalButton";
import Expandable from "../../components/expandable/expandable";
import { useTheme } from "@emotion/react";
import SaveButton from "../../components/saveButton/saveButton";
import InputFields from "../../components/InputFields";
import ButtonContainer from "../../components/buttonContainer";
import TextAreaFields from "../../components/textAreaFields";

const RFTSOtherVendors = (props) => {
    const dispatch = useDispatch();
    const theme = useTheme()

    const { handleSubmit, watch, control, errors, sameProduct, setSameProduct, zeroItems, setZeroItems, open, setOpen, otherVendor } = props
    const [isLoading, setIsLoading] = useState(false)
    const [otherVendorList, setOtherVendorList] = useState([])
    const { vendorList } = useSelector(state => state.filler)

    useEffect(() => {
        console.log(zeroItems,sameProduct)
        if (open && zeroItems.length>0) {
            checkOtherVendors()
        }
    }, [open])

    useEffect(() => {
        if (zeroItems.length == 0 && watch('comment') != "") {
            setOpen(false)
        }
    }, [zeroItems])

    const selectedHeader = ['DIN Number', 'Product Name', 'Vendor', 'Strenght', 'Quantity', 'Same Vendor', 'Other Vendor']
    const selectedParam = ['diN_Master', 'productName', 'vendorValue', 'mg', 'productQty']


    const checkOtherVendors = () => {
        setIsLoading(true)
        let arr = zeroItems.map(e => ({
            "ProductName": e.productName?.trim(),
            "Strength": e.mg,
            "Vendor_ID": e.vendor_ID,
            "PageIndex": null,
            "PageSize": null
        }))
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETPRODUCTAVAILABILITYRFTS",
            "data": arr,
            "debug": null,
            "token": null
        }
        dispatch(getOtherVendorsListRFTS(data)).then(res => {
            console.log(res.payload?.data, zeroItems)
            let arr = []
            res.payload?.data.forEach((ele) => {
                const obj = { ...ele }
                obj['vendorValue'] = filterName(vendorList, obj.vendor_ID)
                arr.push(obj)
            })
            zeroItems.map(item => {
                if (arr.filter(val =>
                    val.productName?.trim() === item?.productName?.trim() && val?.mg == item?.mg
                ).length == 0) {
                    goWithSame(item)
                }
            })
            setOtherVendorList(arr)
            setIsLoading(false)
        })
    }

    const removeItem = (vendor) => {
        // console.log(vendor,zeroItems.findIndex(val => val.productName == vendor.productName && val.mg == vendor.mg))
        let arr = [...otherVendorList]
        const index = arr.findIndex(val => val.productName == vendor.productName && val.mg == vendor.mg)
        arr.splice(index, 1)
        setOtherVendorList(arr)
        let arr2 = [...zeroItems]
        const index2 = arr2.findIndex(val => val.productName == vendor.productName && val.mg == vendor.mg)
        arr2.splice(index2, 1)
        setZeroItems(arr2)
    }
    const goWithOther = (vendor) => {
        console.log(otherVendorList)
        removeItem(vendor)
        otherVendor(vendor)
    }

    const goWithSame = (vendor) => {
        console.log(otherVendorList)
        removeItem(vendor)
        if (!sameProduct.includes(vendor.product_ID)) {
            let arr = [...sameProduct]
            arr.push(vendor.product_ID)
            setSameProduct(arr)
        }
    }

    return (
        <ModalButton open={open} setOpen={setOpen} title={sameProduct.length > 0 && watch('comment') == '' ? 'Please give a comment that why you go with same product' : 'Select other vendor product'}>
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignContent: 'center', flexDirection: 'column' }}>
                {
                    isLoading ? <CircularProgress size={50} sx={{ margin: '20px' }} /> :
                        <>
                            {
                                zeroItems.map(item => {
                                    const filteredVendors = otherVendorList.filter(val =>
                                        val.productName?.trim() === item?.productName?.trim() && val?.mg == item?.mg
                                    );
                                    return (
                                        <Expandable title={`${item?.productName} ${item.mg}`}>
                                            {filteredVendors.length > 0 &&
                                                <><Grid container spacing={1} sx={{ padding: '10px 20px' }}>
                                                    {selectedHeader.map(e => <Grid xs={12 / selectedHeader.length}>
                                                        <Typography>{e}</Typography>
                                                    </Grid>)}
                                                </Grid>
                                                    <Divider sx={{ margin: '10px 0px' }} />
                                                </>
                                            }
                                            {filteredVendors.length > 0 ? (
                                                filteredVendors.map((vendor, i) => (
                                                    < Grid
                                                        container
                                                        spacing={1}
                                                        sx={{
                                                            background: i % 2 ? theme.palette.rowBackground : 'transparent',
                                                            padding: '0px 20px'
                                                        }}
                                                        key={i}
                                                    >
                                                        {selectedParam.map(p => <Grid xs={12 / selectedHeader.length} sx={{ margin: '10px 0px' }}>
                                                            <Typography>{vendor[p]}</Typography>
                                                        </Grid>)}
                                                        <Grid xs={12 / selectedHeader.length}>
                                                            <SaveButton onClick={() => goWithSame(item)} title={'Same vendor'} />
                                                        </Grid>
                                                        <Grid xs={12 / selectedHeader.length}>
                                                            <SaveButton onClick={() => goWithOther(vendor)} title={'Other vendor'} />
                                                        </Grid>

                                                    </Grid >
                                                ))
                                            ) : (
                                                <Typography sx={{ padding: '10px', textAlign: 'center' }}>No vendors available</Typography>
                                            )}
                                        </Expandable>
                                    )
                                })
                            }

                        </>
                }
                {sameProduct.length > 0 && <Grid container>
                    <Grid item xs={6} >
                        <TextAreaFields
                            fieldName="comment"
                            type="text"
                            label="Comment"
                            control={control}
                            rules={{
                                required: "Comment is required",
                            }}
                            error={errors?.comment}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ButtonContainer isSingle>
                            <Button size="medium" variant="contained" color="primary" onClick={handleSubmit(() => setOpen(false))} >Save</Button>
                        </ButtonContainer>
                    </Grid>
                </Grid>}
            </Box>



        </ModalButton >
    )
}

export default RFTSOtherVendors;
